import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  /**
   * Article column: full-bleed `Paper` below `md` (`down('md')`). From `md` up, horizontal inset.
   */
  postMain: {
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  /** Inset when `Paper` is full bleed so trending keeps side margins; same inset from `md` up. */
  postAside: {
    width: '100%',
    boxSizing: 'border-box',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  errorRootContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
  },
  errorLoadingDisclaimer: {
    margin: 0,
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0, 2),
    },
  },
}));
